import React, { useEffect, useState } from 'react';
import './VerificationLandingPage.css';
import { useTranslation } from 'react-i18next';
import { useTvsState } from '../../utils/useTvsState';
import { getUserVerified } from '../../api/tvs/userVerifications';
import { VerificationStatus } from '../../@types/VerificationStatus';
import { ApiResponseError } from '../../api/ApiResponseError';
import { CustomerSegment } from '../../@types/CustomerSegment';
import KybPage from '../kybPage/KybPage';
import KycPage from '../kycPage/KycPage';
import VerificationErrorPage from '../verificationErrorPage/VerificationErrorPage';

interface VerificationLandingPageProps {
  onVerificationComplete?: (status: VerificationStatus) => void;
}

const VerificationLandingPage: React.FC<VerificationLandingPageProps> = ({ onVerificationComplete }) => {
  const [, setTvsState] = useTvsState();
  const [showKybPage, setShowKybPage] = useState<boolean | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const { t } = useTranslation();

  useEffect(() => {
    checkVerificationStatus();
  }, []);

  const checkVerificationStatus = () => {
    getUserVerified()
      .then((response) => {
        if (response?.isVerified === true) {
          setTvsState('verification_success');
          onVerificationComplete?.(VerificationStatus.SUCCESS);
          return;
        }

        if (response?.segmentation === CustomerSegment.NON_CORE_COMMERCIAL_CUSTOMER) {
          setShowKybPage(true);
        } else {
          setShowKybPage(false);
        }
      })
      .catch((error: ApiResponseError) => {
        console.log('inside');
        if (error.responseStatus === 401) {
          setErrorMessage(t('errors.unauthorized'));
        } else {
          setErrorMessage(t('errors.default'));
        }
      });
  };

  return errorMessage ? (
    <VerificationErrorPage errorMessage={errorMessage} />
  ) : showKybPage === null ? null : showKybPage ? (
    <KybPage />
  ) : (
    <KycPage shouldShowErrorMessage={false} onVerificationComplete={onVerificationComplete} />
  );
};

export default VerificationLandingPage;
